import clsx from 'clsx';
import { UseFormRegisterReturn } from 'react-hook-form';

import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

type TextAreaFieldProps = FieldWrapperPassThroughProps & {
  className?: string;
  registration: Partial<UseFormRegisterReturn>;
};

export const TextAreaField = (props: TextAreaFieldProps) => {
  const { label, className, registration, error } = props;
  return (
    <FieldWrapper label={label} error={error}>
      <textarea
        rows={5}
        className={clsx(
          'block w-full appearance-none',
          'rounded-3xl border border-gray-300',
          'px-4 py-3 shadow-sm',
          'focus:border-black focus:outline-none focus:ring-black',
          'sm:text-sm',
          className
        )}
        {...registration}
      />
    </FieldWrapper>
  );
};
